import BaseServiceRead from './BaseServiceRead';
import moment from 'moment';

export default class TransactionService extends BaseServiceRead {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'transaction';
    }

    getCriteria(criteria) {
        let fleetGoodGroupItems = [];
        if (criteria.petrols !== null && criteria.petrols && criteria.petrols.length) {
            criteria.petrols.forEach((element) => {
                fleetGoodGroupItems.push(element.petraId);
            });
        }
        if (criteria.services !== null && criteria.services && criteria.services.length) {
            criteria.services.forEach((element) => {
                fleetGoodGroupItems.push(element.petraId);
            });
        }
        if (criteria.products !== null && criteria.products && criteria.products.length) {
            criteria.products.forEach((element) => {
                fleetGoodGroupItems.push(element.petraId);
            });
        }
        return this.objToQueryString({
            not_invoiced: criteria.unInvoiced,
            phone_number: criteria.phoneNumber,
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format('YYYY-MM-DD') : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format('YYYY-MM-DD') : undefined,
            filter: criteria.filter,
            value_from: criteria.amountFrom ? criteria.amountFrom : undefined,
            value_to: criteria.amountTo ? criteria.amountTo : undefined,
            invoice_number: criteria.invoiceNumber,
            status: criteria.status?.enumValue,
            anw_fleet_good_group: fleetGoodGroupItems,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    getFleetGoodGroups() {
        return this.fetch(`${this.domain}/${this.path}/fleet-good-group`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    editTransaction(request, petraId) {
        return this.fetch(`${this.domain}/${this.path}/edit-fleet-transaction?petraId=${petraId}`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    checkTransactionVideo(request) {
        return this.fetch(`${this.domain}/${this.path}/video-check`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    checkTransactionVideoStartStreaming(request) {
        return this.fetch(`${this.domain}/${this.path}/video-download`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    checkTransactionVideoPartsStatus(request) {
        return this.fetch(`${this.domain}/${this.path}/video-download-status`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getLastTransactionForCardId(cardId) {
        return this.fetch(`${this.domain}/${this.path}/last-for-card/${cardId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getLastTransactionForPhone(phoneNumber) {
        return this.fetch(`${this.domain}/${this.path}/last-for-phone/${phoneNumber}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
